angular.module('tgaAdmin').directive('previewScale', [
  '$window',
  function ($window) {
    return {
      restrict: 'A',
      link($scope, $element) {
        const e = $element[0];
        function onWindowResizePreview() {
          const parent = e.closest('.box');
          const { gameType } = $scope.data;
          if (angular.isUndefined(parent) || parent === null) {
            return;
          }
          if (gameType === 'jump' || gameType === 'match' || gameType === 'detective') {
            const zoomScaleMax = 0.4;
            let scale = zoomScaleMax;
            const parentWidth = Math.abs(parent.clientWidth);
            const proposedScale = parentWidth / 1920;
            if (proposedScale < zoomScaleMax) {
              scale = proposedScale;
            }
            e.style.height = `${Math.floor(1920 * scale)}px`;
            e.style.width = `${Math.floor(1080 * scale)}px`;
            e.children[0].style.transform = `scale(${scale})`;
            e.children[0].style.transformOrigin = 'top left';
          } else {
            const zoomScaleMax = 0.8;
            let scale = zoomScaleMax;
            const parentWidth = Math.abs(parent.clientWidth - 112);
            const proposedScale = parentWidth / 1920;
            if (proposedScale < zoomScaleMax) {
              scale = proposedScale;
            }
            e.style.width = `${Math.floor(1920 * scale)}px`;
            e.style.height = `${Math.floor(1080 * scale)}px`;
            e.children[0].style.transform = `scale(${scale})`;
            e.children[0].style.transformOrigin = 'top left';
          }
        }
        $window.addEventListener('resize', onWindowResizePreview);
        $scope.$on('tabChanged', onWindowResizePreview);
        onWindowResizePreview();
        $scope.$on('$destroy', () => {
          $window.removeEventListener('resize', onWindowResizePreview);
        });
      },
    };
  },
]);
